// extracted by mini-css-extract-plugin
export default {"Title":"HeaderPageList_Title__4IuWI"};